/**
 * Configuration constants for the moving network speed test
 */

export const UPPER_RUN_LIMIT = 15000;
export const DEFAULT_TEST_INTERVAL = 0; // Continuous - as soon as previous finishes
export const MAX_RETRY_ATTEMPTS = 3;
export const RETRY_DELAY = 5000; // 5 seconds
export const NETWORK_CHECK_TIMEOUT = 5000; // 5 seconds for network checks
